import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { api } from "@/lib/api";

export default function SetupBanner() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/setup/status").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s || s.complete || s.dismissed) return null;
  const open = s.steps.filter((x) => !x.done).map((x) => x.label);
  const dismiss = () => api.post("/setup/dismiss").then(() => setS({ ...s, dismissed: true })).catch(() => {});
  return (
    <div className="mb-8 border border-slate-900 bg-white p-5 flex flex-wrap items-center gap-4" data-testid="setup-banner">
      <Sparkles size={18} className="text-[#0a788c]" />
      <div className="flex-1 min-w-[200px] text-sm text-slate-700">
        <b>Einrichtung noch nicht abgeschlossen.</b> Offen: {open.join(", ")}.
      </div>
      <Link to="/einrichtung" className="bg-slate-900 text-white px-4 py-2 text-sm hover:bg-slate-700" data-testid="setup-banner-open">Assistent öffnen</Link>
      <button onClick={dismiss} className="p-2 text-slate-400 hover:text-slate-700" aria-label="Ausblenden" data-testid="setup-banner-dismiss"><X size={14} /></button>
    </div>
  );
}
